import React, { useState, useMemo, useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import YouTube from 'react-youtube';
import { getYoutubeVideoId } from "../../util/util";
import './Carousal.css';

const VideoCarousal = forwardRef((props, ref) => {
    const [videoId, setVideoId] = useState('');
    const youtubeRef = useRef();
    const parser = new DOMParser();
    const dom = parser.parseFromString(props.description, 'text/html');
    const title = parser.parseFromString(props.title, 'text/html');
    const options = {
        playerVars: {
            autoplay: 0,
            loop: 0,
            rel: 0
        },
    };

    useImperativeHandle(ref, () => ({ stopPlayback }));

    useMemo(() => {
        if (props.videoSrc) {
            setVideoId(getYoutubeVideoId(props.videoSrc));
        }
    }, [props.description, props.videoSrc]);

    const handleVideoClick = () => {
        props.onVideoClick();
    };

    const stopPlayback = () => {
        youtubeRef.current.internalPlayer.stopVideo();
        exitFullScreen();
    }

    useEffect(() => {
        if (props.isDotClicked === true || youtubeRef.current) {
            stopPlayback();
        }

    }, []);

    const exitFullScreen = () => {
        if (document.fullscreenElement) {
            document.exitFullscreen();
        }
    }

    return (
        <>
            <div className="videoCarousal-main-div">
                    <img id="video-slide-app-logo" src={props.logoSrc} className="video-slide-app-logo" alt="app logo" />
            </div>
            <div>
                <div dangerouslySetInnerHTML={{ __html: title.body.innerHTML }} />
            </div>
            {props.fileType === "mp4" ? (
                <div><video id="slide-video" className='slide-video' /></div>
            ) : (
                <div id="slide-video-container" className="slide-video-container">
                    <YouTube id="slide-video" className="slide-video" opts={options} videoId={videoId} onPlay={handleVideoClick} onEnd={handleVideoClick} ref={youtubeRef} />
                </div>
            )}
            <div id="carausal-list-item-content" className="carausal-list-item-content video-carousal-list-item-content" dangerouslySetInnerHTML={{ __html: dom.body.innerHTML }} />
        </>
    );
});

export default VideoCarousal;